module.exports = __webpack_public_path__ + "img/LotteryTips.060d01a6.png";